<template>
  <div>
    <!-- modelo impresion -->
    <div>
      <div style="display: flex;">
        <div style="flex: 1; padding: 4px; border: 1px solid black; text-align: center;">
          <img :src="user.cuenta.uriImagen" alt="Logo" />
        </div>
        <div style="flex: 1; padding: 4px; border: 1px solid black;text-align: center;">
          <div>{{ user.cuenta.razonSocial }}</div>
          <div>{{ user.cuenta.nombreComercial }}</div>
          <div>{{ user.cuenta.direccion.direccion }}</div>
        </div>
      </div>
      <div v-if="datosTicket" style="display: flex;width: 100%;">
        <div style="width: 15%; padding: 4px; border: 1px solid black;">Destinatario</div>
        <div style="width: 85%; padding: 4px; border: 1px solid black;">{{ datosTicket.receiver.razonSocial }}</div>
      </div>
      <div v-if="datosTicket" style="display: flex;width: 100%;">
        <div style="width: 15%; padding: 4px; border: 1px solid black;">Nombre Destinatario</div>
        <div style="width: 30%; padding: 4px; border: 1px solid black;">
          <b-form-input 
            v-model="nombre" 
            type="text">
          </b-form-input>
        </div>
        <div style="width: 15%; padding: 4px; border: 1px solid black;">Doc. Identidad</div>
        <div style="width: 40%; padding: 4px; border: 1px solid black;">
          <b-form-input 
            @input="validateInput(8, 'docIdentidad')"
            @keydown="allowOnlyDeleteAndNumbers($event, 8, 'docIdentidad')" 
            v-model="docIdentidad"
            type="number">
          </b-form-input>
        </div>
      </div>
      <div v-if="datosTicket" style="display: flex;width: 100%;">
        <div style="width: 15%; padding: 4px; border: 1px solid black;">Tefl / Celular</div>
        <div style="width: 30%; padding: 4px; border: 1px solid black;">
          <b-form-input 
              @input="validateInput(9, 'numCelTicket')"
              @keydown="allowOnlyDeleteAndNumbers($event, 9, 'numCelTicket')" 
              type="number" 
              v-model="numCelTicket">
          </b-form-input>
        </div>
        <div style="width: 15%; padding: 4px; border: 1px solid black;">Documento</div>
        <div style="width: 40%; padding: 4px; border: 1px solid black;">{{ datosTicket.receiver.idReceptor }}</div>
      </div>
      <div v-if="datosTicket" style="display: flex;width: 100%;">
        <div style="width: 15%; padding: 4px; border: 1px solid black;">Destino</div>
        <div style="width: 85%; padding: 4px; border: 1px solid black;">
          <b-form-input 
            v-model="datosTicket.receiver.direccionReferencia">
          </b-form-input>
        </div>
      </div>
      <div v-if="datosTicket" style="display: flex;width: 100%;">
        <div style="width: 15%; padding: 4px; border: 1px solid black;">Serie - Num</div>
        <div style="width: 30%; padding: 4px; border: 1px solid black;">{{ datosTicket.serie }} - {{ datosTicket.numero }}</div>
        <div style="width: 15%; padding: 4px; border: 1px solid black;">Observaciones</div>
        <div style="width: 40%; padding: 4px; border: 1px solid black;">
          <b-form-input 
              maxlength="40" 
              type="text" 
              v-model="obsTicket">
          </b-form-input>
        </div>
      </div>
    </div>
    <!-- vista impresion -->
    <div id="printme" style="display: none;" class="ticket-print">
      <div style="display: flex;">
        <div style="flex: 1; padding: 4px; border: 1px solid black; text-align: center;">
          <img :src="user.cuenta.uriImagen" alt="Logo" />
        </div>
        <div style="flex: 1; padding: 4px; border: 1px solid black;text-align: center;">
          <div>{{ user.cuenta.razonSocial }}</div>
          <div>{{ user.cuenta.nombreComercial }}</div>
          <div>{{ user.cuenta.direccion.direccion }}</div>
        </div>
      </div>
      <div v-if="datosTicket" style="display: flex;width: 100%;">
        <div style="width: 14.4%; padding: 4px; border: 1px solid black;">Destinatario</div>
        <div style="width: 85%; padding: 4px; border: 1px solid black;">{{ datosTicket.receiver.razonSocial }}</div>
      </div>
      <div v-if="datosTicket" style="display: flex;width: 100%;">
        <div style="width: 15%; padding: 4px; border: 1px solid black;">Nombre Destinatario</div>
        <div style="width: 30%; padding: 4px; border: 1px solid black;">{{ nombre }}</div>
        <div style="width: 15%; padding: 4px; border: 1px solid black;">Doc. Identidad</div>
        <div style="width: 40%; padding: 4px; border: 1px solid black;">{{ docIdentidad }}</div>
      </div>
      <div v-if="datosTicket" style="display: flex;width: 100%;">
        <div style="width: 15%; padding: 4px; border: 1px solid black;">Tefl / Celular</div>
        <div style="width: 30%; padding: 4px; border: 1px solid black;">{{ numCelTicket }}</div>
        <div style="width: 15%; padding: 4px; border: 1px solid black;">Documento</div>
        <div style="width: 40%; padding: 4px; border: 1px solid black;">{{ datosTicket.receiver.idReceptor }}</div>
      </div>
      <div v-if="datosTicket" style="display: flex;width: 100%;">
        <div style="width: 14.4%; padding: 4px; border: 1px solid black;">Destino</div>
        <div style="width: 85%; padding: 4px; border: 1px solid black;">{{ datosTicket.receiver.direccionReferencia }}</div>
      </div>
      <div v-if="datosTicket" style="display: flex;width: 100%;">
        <div style="width: 15%; padding: 4px; border: 1px solid black;">Serie - Num</div>
        <div style="width: 30%; padding: 4px; border: 1px solid black;">{{ datosTicket.serie }} - {{ datosTicket.numero }}</div>
        <div style="width: 15%; padding: 4px; border: 1px solid black;">Observaciones</div>
        <div style="width: 40%; padding: 4px; border: 1px solid black;">{{ obsTicket }}</div>
      </div>
    </div>
  </div>
</template>
<script>

export default {
    name: 'Ticket',
    props:['impresion','printweb'],
    data() {
        return {
            datosTicket:'',
            user: {
                username: "",
                rol: "",
                idEmisor: "",
                cuenta: {
                razonSocial: "",
                direccion: {}
                }
            },
            numCelTicket:'',
            obsTicket:'',
            nombre:'',
            docIdentidad:''
        }
    },
    mounted() {
        this.setData(),
        this.userData()
    },
    watch: {
      printweb(val) {
        if (val) {
          this.imprimirTicket();
        }
      },
    },
    methods:{
      imprimirTicket() {
        var printContents = document.getElementById("printme").innerHTML
                    var myWindow = window.open("", "MsgWindow", "width=400,height=800")
                    myWindow.document.body.style.fontSize='10px'
                    myWindow.document.body.style.textAlign='center'
                    myWindow.document.write(printContents)
                    myWindow.print(printContents)
                    myWindow.close()
      setTimeout(() => {
        this.$emit('update:printweb', false);
      }, 500);
    },
      setData: function () {
        this.datosTicket = this.impresion
      },
      userData: function() {
        this.user = this.$store.getters.userData;
      },
      validateInput(max, field) {
        if (this[field].length > max) {
          this[field] = this[field].slice(0, max);
        }
      },
      allowOnlyDeleteAndNumbers(e, max, field) {
        const isNumber = e.key >= '0' && e.key <= '9';
        const isDelete = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'].includes(e.key);
        if (!isNumber && !isDelete) {
          e.preventDefault();
        }
        if (this[field].length >= max && isNumber) {
          e.preventDefault();
        }
      }
    }
};
</script>
<style scoped>
</style>